import React from "react";

export function EmptyState({ icon: Icon, title, description, action, testid }) {
  return (
    <div
      data-testid={testid}
      className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-[#E5E0D8] bg-white/60 px-6 py-16 text-center"
    >
      {Icon && (
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#F0ECE1] text-[#0D5C3A]">
          <Icon className="h-7 w-7" strokeWidth={1.5} />
        </div>
      )}
      <h3 className="font-heading text-lg font-semibold text-stone-800">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-stone-500">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export function Loader({ label = "Loading…" }) {
  return (
    <div className="flex items-center justify-center gap-2 py-20 text-sm text-stone-500">
      <div className="h-4 w-4 animate-spin rounded-full border-2 border-[#0D5C3A] border-t-transparent" />
      {label}
    </div>
  );
}
